import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { OLButton } from "OLButton";
import React from "react";
import "react-loading-skeleton/dist/skeleton.css";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    submitContainer: {
      alignItems: "center",
      display: "flex",
      gap: theme.spacing(12),
      justifyContent: "flex-end",
      marginBottom: theme.spacing(20),
    },
  }),
);

export interface ButtonsProps {
  disableSubmit?: boolean;
  onCancelClick: React.MouseEventHandler<HTMLButtonElement>;
  onSubmitClick: React.MouseEventHandler<HTMLButtonElement>;
  submitMessage?: string;
  cancelMessage?: string;
  className?: string;
  "data-test-id"?: string;
}

export const FormButtons = ({
  disableSubmit,
  onCancelClick,
  onSubmitClick,
  submitMessage,
  cancelMessage,
  className = "",
  "data-test-id": dataTestId,
}: ButtonsProps) => {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <div className={`${classes.submitContainer} ${className}`}>
      <OLButton
        data-test-id="cancel-button"
        onClick={onCancelClick}
        size="medium"
        variant="outlined"
      >
        {message({ id: cancelMessage || "cancel" })}
      </OLButton>
      <OLButton
        color="primary"
        data-test-id={dataTestId || "submit-button"}
        disabled={disableSubmit}
        onClick={onSubmitClick}
        variant="contained"
      >
        {message({ id: submitMessage || "saveChanges" })}
      </OLButton>
    </div>
  );
};
